import React, { useState , useEffect} from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  TableContainer,
  Paper,
  TextField,
  Box,
  Button,Autocomplete,Checkbox,MenuItem,IconButton,
} from "@mui/material";
import { GlobalStyles } from "@mui/system";
import {ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAuth } from "../../../AuthProvider";
import DeleteIcon from "@mui/icons-material/Delete";
import Swal from "sweetalert2";
import { CircularProgress } from "@mui/material";



const baseUrl = process.env.REACT_APP_API_BASE_URL;
function NoticeBoard() {
  const {pId,oId}=useAuth();
  const [title, setTitle] = useState("");
  const [purposeDate, setDate] = useState("");
  // const [time, setTime] = useState("");
  const [description, setDescription] = useState("");
  const [nameOfCreatedByNotice, setnameOfCreatedByNotice] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [notices, setNotices] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loadingData, setLoadingData] = useState(true); // ✅ Define loading state


 
    const fetchNotices = async () => {
      setLoadingData(true); // Start loading
      try {
        const response = await fetch(`${baseUrl}/api/noticeBoard/getAll/${oId}/${pId}`); // Replace with your API URL
        const data = await response.json();
        // ✅ Sort notices by purposeDate (future dates first)
         data.sort((a, b) => new Date(b.purposeDate) - new Date(a.purposeDate));

        setNotices(data); // Assuming the response is an array
      } catch (error) {
        console.error("Error fetching notices:", error);
      }finally {
        setLoadingData(false); // Stop loading
      }
    };
  useEffect(() => {
    fetchNotices();
  }, []);


  const validate = () => {
    let tempErrors = {};
    if (!title) tempErrors.title = "Title is required";
    if (!purposeDate) {
      tempErrors.purposeDate = "Date is required";
    } else {
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Reset hours to compare only dates
      const selectedDate = new Date(purposeDate);
      
      if (selectedDate < today) {
        tempErrors.purposeDate = "Notice date cannot be in the past";
      }
    }
    
    // if (!time) tempErrors.time = "Time is required";
    if (!description) tempErrors.description = "Description is required";
    if (!nameOfCreatedByNotice) tempErrors.nameOfCreatedByNotice = "Name is required";
    
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleChange = (field, value) => {
    setErrors((prevErrors) => ({ ...prevErrors, [field]: "" })); // Clear error for that field
    if (field === "title") setTitle(value);
    if (field === "purposeDate") setDate(value);
    // if (field === "time") setTime(value);
    if (field === "description") setDescription(value);
    if (field === "nameOfCreatedByNotice") setnameOfCreatedByNotice(value);
  };


 // Filter notices based on search query
const handleSubmit = async (e) => {
  e.preventDefault();
  if (!validate()) return;

  setLoading(true);

  const formData = new FormData();
  formData.append("title", title);
  formData.append("purposeDate", purposeDate);
  formData.append("description", description);
  formData.append("nameOfCreatedByNotice", nameOfCreatedByNotice);

  try {
    const response = await fetch(`${baseUrl}/api/noticeBoard/create/${pId}`, {
      method: "POST",
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`Failed to send notice. Status: ${response.status}`);
    }

    // ✅ Read as text since backend returns plain string
    const message = await response.text();
    console.log("Server response:", message);

    toast.success("Notice Sent Successfully!");
    setTitle("")
    setDate("")
    setDescription("")
    setnameOfCreatedByNotice("")
    fetchNotices();
  } catch (error) {
    toast.error("Failed to send notice. Please try again.");
    console.error("Error:", error);
  } finally {
    setLoading(false);
  }
};


 
 
 const filteredNotices = notices.filter((notice) => {
  return (
    notice.title.toLowerCase().includes(searchQuery.toLowerCase()) || 
    notice.purposeDate.toLowerCase().includes(searchQuery.toLowerCase())
    // formattedDate.includes(searchQuery)
  );
});


const handleDelete = async (data) => {
  Swal.fire({
    title: "Are you sure?",
    text: `You Want To Delete Notice "${data.title}" From The List!`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Yes, delete it!",
  }).then(async (result) => {
    if (result.isConfirmed) {
      try {
        const response = await fetch(`${baseUrl}/api/noticeBoard/delete/${oId}/${data.id}`, {
          method: "DELETE",
        });

        if (response.ok) {
         
          toast.success("Notice Deleted Successfully!");
          fetchNotices();
          // Optionally refresh notices after deletion
        } else {
         
          toast.error("Failed to delete notice.");
        }
      } catch (error) {
       
        toast.error("An error occurred. Please try again.");
        console.error("Error:", error);
      }
    }
  });
};


  return (
    <Card
      style={{
        margin: "60px 20px",
        padding: "10px",
        backgroundColor: "#fff",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        borderRadius: "8px",
        maxHeight: "160vh",
        overflow: "hidden",
      }}
    >
      <CardContent>
        {/* Title Section */}
        
            <Typography
              variant="h4"
              style={{ fontWeight: "bold", color: "#333",  textAlign:'center'}}
            >
              Notice Board
            </Typography>
        

        {/* Two Side-by-Side Boxes */}
        <Grid container spacing={2} sx={{ marginTop: "1px",alignItems:'stretch' }}> {/* Reduced margin between table and filter boxes */}
          {/* box 1 */}
           <Grid item xs={12} md={4}>
      <Box
        sx={{
          padding: "15px",
          borderRadius: "8px",
          boxShadow: "0px 6px 20px rgba(0, 0, 0, 0.25)",

          backgroundColor: "#ffffff",
        
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: "bold", color: "#333", marginBottom: "15px" }}>
          Schedule New Notice
        </Typography>
        
        <TextField
          label="Title"
          fullWidth
          value={title}
          onChange={(e) => handleChange("title", e.target.value)}
          error={!!errors.title}
          helperText={errors.title}
          sx={{ marginBottom: "15px" }}
        />


        <TextField
          label="Date"
          type="date"
          fullWidth
          value={purposeDate}
          onChange={(e) => handleChange("purposeDate", e.target.value)}
          error={!!errors.purposeDate}
          helperText={errors.purposeDate}
          sx={{ marginBottom: "15px" }}
          InputLabelProps={{ shrink: true }}
        />
      
        <TextField
          label="Notice Purpose"
          fullWidth
          multiline
          rows={4}
          value={description}
          onChange={(e) => handleChange("description", e.target.value)}
          error={!!errors.description}
          helperText={errors.description}
          sx={{ marginBottom: "15px" }}
        />

        <TextField
          label="Notice Created By"
          fullWidth
          value={nameOfCreatedByNotice}
          onChange={(e) => handleChange("nameOfCreatedByNotice", e.target.value)}
          error={!!errors.nameOfCreatedByNotice}
          helperText={errors.nameOfCreatedByNotice}
          sx={{ marginBottom: "10px" }}
          placeholder="Name"
        />
<Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2,mb:2 }} >
  <Button 
    variant="contained" 
    color="primary" 
    sx={{
      backgroundColor: "#3C3972",
      float: "right",
      // marginBottom: "10px",
      color: "#fff",
      width: "150px", // Set a fixed width to prevent shrinking
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "&:hover": { backgroundColor: "#3C3972" },
    }}
    onClick={handleSubmit}
    disabled={loading}
  >
    {loading ? (
      <>
        <CircularProgress size={24} sx={{ color: "#fff", marginRight: "8px" }} />
        Creating...
      </>
    ) : (
      "Create Notice"
    )}
  </Button>
</Box>



      </Box>
    </Grid>


          {/* box 2 */}
          <Grid item xs={12} md={8}>
       
  {/* Scrollable Container */}
  <Box
  sx={{
    padding: "15px",
    borderRadius: "8px",
    // boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
    boxShadow: "0px 6px 20px rgba(0, 0, 0, 0.25)",
    backgroundColor: "#f9f9f9",
  }}
>
  <Typography variant="h5" sx={{ fontWeight: "bold", color: "#333", marginBottom: "15px" }}>
    Scheduled Notices
  </Typography>

  {/* Search by Date and Title */}
  {/* Search Input */}
  <Grid container spacing={2} sx={{ marginBottom: "15px" }}>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Search by Date or Title"
            fullWidth
            size="small"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </Grid>
      </Grid>

  {/* Horizontal Line */}
  <Box sx={{ borderBottom: "1px solid #ddd", marginBottom: "15px" }} />
  <GlobalStyles
          styles={{
            '.custom-sidebar-scrollbar': {
              scrollbarWidth: 'thin', // For Firefox
              scrollbarColor: 'grey #e0e0e0',
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar': {
              width: '6px', // For WebKit-based browsers
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar-track': {
              background: '#f1f1f1', // Track color
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb': {
              backgroundColor: 'grey', // Thumb color
              borderRadius: '10px',
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover': {
              backgroundColor: '#555',
            },
          }}
        />

  {/* Scrollable Container */}
  <Box sx={{ maxHeight: "400px", overflowY: "auto", padding: "10px" }} className="custom-sidebar-scrollbar">
      <Grid container spacing={2}>
        {
        loadingData ? ( // Show loader when loading
          <Box display="flex" flexDirection="column" alignItems="center" width="100%" sx={{ mt: 2 }}>
            <CircularProgress />
            <Typography variant="body2" sx={{ mt: 1 }}>
              Loading Notices...
            </Typography>
          </Box>
         ) : filteredNotices.length === 0 ? (
          <Typography
            variant="h6"
            sx={{ textAlign: "center", color: "#666", width: "100%", padding: "20px", fontStyle: "italic" }}
          >
            No notices available. Create a new notice.
          </Typography>
        ) : (
          filteredNotices.map((data, index) => (
            <Grid item xs={12} key={index}>
               <Box
                                sx={{
                                  padding: "10px",
                                  borderRadius: "10px",
                                  boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
                                  backgroundColor: "#D1E9F6",
                                  position: "relative",
                                  overflow: "hidden",
                                  marginTop: "10px",
                                  transition: "all 0.2s ease-in-out",
                                  "&:hover": {
                                    backgroundColor: "#b3d8ec",
                                  },
                                  "&:hover .delete-button": { opacity: 1 },
                                }}
                              >
                                {/* "New!" Ribbon Badge - Properly Aligned */}
                                {new Date() - new Date(data.purposeDate) < 24 * 60 * 60 * 1000 && (
                                  <Box
                                    sx={{
                                      position: "absolute",
                                      top: "0",
                                      right: "0",
                                      // backgroundColor: "#ff0000",
                                      backgroundColor: "blue",
                                      color: "#fff",
                                      fontWeight: "bold",
                                      fontSize: "0.75rem",
                                      padding: "6px 12px",
                                      textTransform: "uppercase",
                                      borderTopRightRadius: "8px",
                                      borderBottomLeftRadius: "8px",
                                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                                    }}
                                  >
                                    New!
                                  </Box>
                                )}


  {/* Delete Icon - Now positioned correctly and shown only on hover */}
  <IconButton
    className="delete-button"
    sx={{
      position: "absolute",
      right: "10px",
      top: "50%",
      transform: "translateY(-50%)",
      backgroundColor: "#ff0000",
      color: "#fff",
      opacity: 0,
      transition: "opacity 0.2s ease-in-out",
      "&:hover": { backgroundColor: "#d32f2f" },
    }}
    onClick={() => handleDelete(data)}
  >
    <DeleteIcon />
  </IconButton>
              
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px",
                                  }}
                                >
                                  {/* Date Box */}
                                  <Box
                                    sx={{
                                      backgroundColor: "#4CAF50",
                                      color: "#fff",
                                      borderRadius: "8px",
                                      padding: "10px",
                                      fontSize: "0.9rem",
                                      fontWeight: "bold",
                                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                                      "&:hover": {
                                        backgroundColor: "#388E3C",
                                        transform: "scale(1.05)",
                                      },
                                    }}
                                  >
                                    {/* {new Date(data.date).toLocaleDateString()} */}
                                    {data.purposeDate}
                                  </Box>
              
                                 
                                </div>
              
                                {/* Title */}
                                <Typography
                                  variant="h5"
                                  sx={{ fontWeight: "bold", color: "#333", marginTop: "10px" }}
                                >
                                  {data.title}
                                </Typography>
              
                                {/* Description */}
                                <Typography
                                  variant="body2"
                                  sx={{ marginTop: "5px", color: "#666", fontWeight: "bold" }}
                                >
                                  {data.description}
                                </Typography>
              
                                {/* Created By */}
                                <Typography
                                  variant="body2"
                                  sx={{ marginTop: "5px", fontStyle: "italic", color: "#444" }}
                                >
                                  Created by: {data.nameOfCreatedByNotice}
                                  {/* Time:{" "} */}
                                  {/* <span>{data.time}</span> */}
                                </Typography>
                              </Box>
            </Grid>
          ))
        )}
      </Grid>
    </Box>
</Box>



 {/* Toast Container */}
 <ToastContainer position="top-right" autoClose={1000} />
 
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}

export default NoticeBoard;